@if (showArchive) {
  <button
    mat-icon-button
    (click)="archiveProjectsEvent.emit(true)"
    matTooltip="Archive"
    matTooltipPosition="above"
    i18n-matTooltip
  >
    <mat-icon>archive</mat-icon>
  </button>
}
@if (!showArchive) {
  <button
    mat-icon-button
    (click)="archiveProjectsEvent.emit(false)"
    matTooltip="Restore"
    matTooltipPosition="above"
    i18n-matTooltip
  >
    <mat-icon>unarchive</mat-icon>
  </button>
}
